export default "__VITE_ASSET__DwU9qvVJ__"